import React, { FunctionComponent } from 'react';
import styles from './blog-hero.module.scss';

export interface IBlogHeroProps {
  backgroundImage: {
    url: string;
    description: string;
  };
  subTitle: string;
  description: string;
  title: string;
}

export const BlogHero: FunctionComponent<IBlogHeroProps> = ({
  backgroundImage,
  subTitle,
  description,
  title
}) => {
  const descriptions = description.split('\n\n');
  return (
    <div
      className={styles.container}
      style={{ backgroundImage: `url(${backgroundImage.url})` }}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <div
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          ></div>
          <h3 className={styles.subTitle}>{subTitle}</h3>
          {descriptions.map(line => (
            <p className={styles.description}>{line}</p>
          ))}
        </div>
      </div>
    </div>
  );
};
